module.exports = __webpack_public_path__ + "static/media/UnderConstructions.a46fd3ef.svg";